(function(){
  var root =
    (document.currentScript && document.currentScript.closest && document.currentScript.closest('[data-coh-archive]')) ||
    document.querySelector('[data-coh-archive]');

  if(!root || root.dataset.cohInit === '1') return;
  root.dataset.cohInit = '1';

  var enterBtn = root.querySelector('[data-enter]');
  var exitBtn  = root.querySelector('[data-exit]');
  var skipBtn  = root.querySelector('[data-skip]');

  var boot = root.querySelector('[data-boot]');
  var bootLinesEl = root.querySelector('[data-boot-lines]');
  var bootTagEl = root.querySelector('[data-boot-tag]');
  var bootStateEl = root.querySelector('[data-boot-state]');
  var bootTitleEl = root.querySelector('[data-boot-title]');

  var cursor = root.querySelector('.coh-cursor');

  // ⚠️ Importante: capturamos modal desde el root y luego lo movemos a body
  var modal = root.querySelector('[data-modal]');
  var openArchiveBtn = root.querySelector('[data-open-archive]');
  var modalCloseEls = (modal ? modal.querySelectorAll('[data-modal-close]') : []);
  var gridItems = (modal ? modal.querySelectorAll('.coh-grid__item') : []);

  var paneImg  = (modal ? modal.querySelector('[data-pane-img]') : null);
  var paneName = (modal ? modal.querySelector('[data-pane-name]') : null);
  var paneRef  = (modal ? modal.querySelector('[data-pane-ref]') : null);
  var paneOld  = (modal ? modal.querySelector('[data-pane-price-old]') : null);
  var paneNew  = (modal ? modal.querySelector('[data-pane-price-new]') : null);

  var prefersReduce = false;
  try { prefersReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch(e){}

  var canHover = false;
  try { canHover = window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches; } catch(e){}

  var entered = false;
  var booting = false;
  var modalOpen = false;
  var lastFocus = null;
  var lastEnterDur = 0;

  // ✅ FIX CRÍTICO: mover modal al <body> para que no lo corte ningún contenedor
  if(modal && modal.parentNode !== document.body){
    document.body.appendChild(modal);
  }

  // cursor
  function moveCursor(e){
    if(!cursor) return;
    var rect = root.getBoundingClientRect();
    cursor.style.left = (e.clientX - rect.left) + 'px';
    cursor.style.top  = (e.clientY - rect.top)  + 'px';
  }
  root.addEventListener('mouseenter', function(){ root.classList.add('is-hover'); });
  root.addEventListener('mouseleave', function(){ root.classList.remove('is-hover'); root.classList.remove('is-focus'); });
  root.addEventListener('mousemove', moveCursor);

  // boot
  function setBoot(lines, tag, state, title){
    if(bootLinesEl) bootLinesEl.textContent = lines.join("\n");
    if(bootTagEl && tag) bootTagEl.textContent = tag;
    if(bootStateEl && state) bootStateEl.textContent = state;
    if(bootTitleEl && title) bootTitleEl.textContent = title;
  }

  var lineTimer = 0;
  function runBootSequence(){
    var steps = [
      { t: 0,    tag:"ARCHIVE", state:"SYNC",  title:"COHERENCE",
        lines:["handshake: mercader.core","channel: archive.index","status: pending"]},
      { t: 900,  tag:"INDEX", state:"SCAN", title:"COHERENCE",
        lines:["indexing: product imagery","normalizing: composition / scale","signal: stable"]},
      { t: 2000, tag:"PRINCIPLES", state:"ALIGN", title:"COHERENCE",
        lines:["constraint: not in identity","transition: in principles","noise: reduced"]},
      { t: 3500, tag:"ACCESS", state:"OPEN", title:"COHERENCE",
        lines:["archive: ready","ui: minimal","opening: interface"]}
    ];

    var start = Date.now();
    var lastStep = -1;

    clearInterval(lineTimer);
    lineTimer = setInterval(function(){
      var now = Date.now() - start;
      for(var i=steps.length-1; i>=0; i--){
        if(now >= steps[i].t){
          if(lastStep !== i){
            lastStep = i;
            setBoot(steps[i].lines, steps[i].tag, steps[i].state, steps[i].title);
          }
          break;
        }
      }
    }, 70);
  }

  function enter(fast){
    if(entered || booting) return;
    booting = true;

    if(enterBtn) enterBtn.setAttribute('aria-pressed','true');
    if(boot){
      boot.hidden = false;
      boot.setAttribute('aria-hidden', 'false');
    }
    root.classList.add('is-booting');

    var dur = prefersReduce ? 260 : (fast ? 680 : 4200);
    lastEnterDur = dur;

    if(!prefersReduce && !fast) runBootSequence();
    else setBoot(["opening: interface"], "ARCHIVE", "OPEN", "COHERENCE");

    setTimeout(function(){
      clearInterval(lineTimer);
      root.classList.remove('is-booting');
      root.classList.add('is-entered');
      entered = true;
      booting = false;

      setTimeout(function(){
        if(boot){
          boot.hidden = true;
          boot.setAttribute('aria-hidden', 'true');
        }
      }, 180);
    }, dur);
  }

  function resetToStart(){
    closeModal(true);
    root.classList.remove('is-entered');
    root.classList.remove('is-booting');
    entered = false;
    booting = false;
    clearInterval(lineTimer);

    if(enterBtn) enterBtn.setAttribute('aria-pressed','false');
    if(boot){
      boot.hidden = true;
      boot.setAttribute('aria-hidden','true');
    }

    try{ root.scrollIntoView({ behavior: 'smooth', block: 'start' }); }catch(e){}
  }

  if(enterBtn){
    enterBtn.addEventListener('click', function(e){ e.preventDefault(); enter(false); });
    enterBtn.addEventListener('keydown', function(e){
      if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); enter(false); }
    });
  }
  if(exitBtn){
    exitBtn.addEventListener('click', function(e){ e.preventDefault(); resetToStart(); });
  }

  // ===== prices (/products/<handle>.js) =====
  function getHandleFromHref(href){
    try{
      var u = new URL(href, window.location.origin);
      var m = (u.pathname || "").match(/\/products\/([^\/\?]+)/);
      return m ? m[1] : null;
    }catch(e){ return null; }
  }

  // ✅ SIN DECIMALES (para que no se corte)
  function formatEURFromCents(cents){
    var n = Number(cents);
    if(!isFinite(n)) return "";
    var v = Math.round(n / 100);
    return "€" + v;
  }

  function applyPrice(item, priceCents, compareCents){
    var newEl = item.querySelector('[data-price-new]');
    var oldEl = item.querySelector('[data-price-old]');
    if(!newEl || !oldEl) return;

    var p = Number(priceCents);
    var c = Number(compareCents);

    var newText = formatEURFromCents(p);
    newEl.textContent = newText || "";

    var oldText = "";
    if(isFinite(p) && isFinite(c) && c > p && c > 0){
      oldText = formatEURFromCents(c);
      oldEl.style.display = "";
      oldEl.textContent = oldText;
    }else{
      oldEl.textContent = "";
      oldEl.style.display = "none";
    }

    item.dataset.priceNewText = newText || "";
    item.dataset.priceOldText = oldText || "";
  }

  function hydratePrices(){
    if(!gridItems || !gridItems.length) return;

    var items = Array.prototype.slice.call(gridItems);
    var q = items.slice();
    var active = 0;
    var MAX = 6;

    function runNext(){
      while(active < MAX && q.length){
        (function(item){
          active++;

          var href = item.getAttribute('href') || "";
          var handle = getHandleFromHref(href);
          if(!handle){
            active--;
            runNext();
            return;
          }

          var cacheKey = "coh_price_" + handle;
          try{
            var cached = sessionStorage.getItem(cacheKey);
            if(cached){
              var obj = JSON.parse(cached);
              if(obj && obj.p != null){
                applyPrice(item, obj.p, obj.c);
                active--;
                runNext();
                return;
              }
            }
          }catch(e){}

          fetch("/products/" + handle + ".js", { credentials: "same-origin" })
            .then(function(r){ return r && r.ok ? r.json() : null; })
            .then(function(data){
              if(!data) return;
              applyPrice(item, data.price, data.compare_at_price);

              try{
                sessionStorage.setItem(cacheKey, JSON.stringify({ p: data.price, c: data.compare_at_price, t: Date.now() }));
              }catch(e){}
            })
            .catch(function(){})
            .finally(function(){
              active--;
              runNext();
            });
        })(q.shift());
      }
    }
    runNext();
  }

  // ===== modal scroll lock =====
  var lockY = 0;
  function lockScroll(){
    lockY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = (-lockY) + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }
  function unlockScroll(){
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, lockY || 0);
    lockY = 0;
  }

  function setPreviewFromItem(item){
    if(!item) return;

    var img = item.getAttribute('data-img') || '';
    var name = item.getAttribute('data-name') || '';
    var ref = item.getAttribute('data-ref') || '';

    if(paneImg && img){
      paneImg.src = img;
      paneImg.alt = name ? (name + ' preview') : 'Preview';
    }
    if(paneName) paneName.textContent = name || 'ARCHIVE';
    if(paneRef) paneRef.textContent = ref || '';

    if(paneOld){
      var tOld = item.dataset.priceOldText || '';
      paneOld.textContent = tOld;
      paneOld.style.display = tOld ? "" : "none";
    }
    if(paneNew) paneNew.textContent = item.dataset.priceNewText || '';
  }

  function primePreviewFromFirst(){
    var first = gridItems && gridItems[0];
    if(!first) return;
    setPreviewFromItem(first);
  }

  function openModal(){
    if(!entered || !modal) return;
    if(modalOpen) return;

    lastFocus = document.activeElement;

    modal.hidden = false;
    modal.setAttribute('aria-hidden','false');
    modal.classList.add('is-open');
    modalOpen = true;

    // ✅ siempre arriba
    modal.scrollTop = 0;

    lockScroll();
    hydratePrices();
    primePreviewFromFirst();

    setTimeout(function(){
      var x = modal.querySelector('.coh-modal__x');
      if(x) x.focus();
    }, 20);
  }

  function closeModal(silent){
    if(!modal || !modalOpen) return;

    modal.classList.remove('is-open');
    modalOpen = false;

    unlockScroll();

    setTimeout(function(){
      modal.hidden = true;
      modal.setAttribute('aria-hidden','true');
      if(!silent && lastFocus && lastFocus.focus) lastFocus.focus();
      lastFocus = null;
    }, 160);
  }

  if(openArchiveBtn){
    openArchiveBtn.addEventListener('click', function(e){
      e.preventDefault();
      openModal();
    });
  }

  if(skipBtn){
    skipBtn.addEventListener('click', function(e){
      e.preventDefault();
      if(modalOpen) return;

      if(entered){
        openModal();
        return;
      }

      enter(true);
      setTimeout(function(){
        openModal();
      }, (lastEnterDur || 680) + 90);
    });
  }

  if(modalCloseEls && modalCloseEls.length){
    Array.prototype.forEach.call(modalCloseEls, function(el){
      el.addEventListener('click', function(e){
        e.preventDefault();
        closeModal(false);
      });
    });
  }

  if(gridItems && gridItems.length){
    Array.prototype.forEach.call(gridItems, function(item){
      item.addEventListener('mouseenter', function(){
        if(!modalOpen) return;
        if(!canHover) return;
        setPreviewFromItem(item);
      });
      item.addEventListener('focus', function(){
        if(!modalOpen) return;
        setPreviewFromItem(item);
      });
    });
  }

  window.addEventListener('keydown', function(e){
    if(e.key === 'Escape'){
      if(modalOpen){ closeModal(false); return; }
      if(entered){ resetToStart(); }
    }
  });

  root.tabIndex = 0;
  root.addEventListener('keydown', function(e){
    if(!entered && (e.key === 'Enter' || e.key === ' ')){
      e.preventDefault(); enter(false);
    }
  });
})();